import React, { useEffect, Suspense } from "react"
import { HashRouter, Route, Routes } from "react-router-dom"
import CircularProgress from "@mui/material/CircularProgress"
import Typography from "@mui/material/Typography"

import "./scss/style.scss"
import routes from "src/dashboardRoutes"
import MyAccount from "./pages/my_account/MyAccount"
import Product from "./pages/product/Product"

const loading = (
    <div className="h-100vh d-flex">
        <div className="d-flex flex-column m-auto">
            <CircularProgress />
            <Typography variant="caption" className="mt-3" color="primary">Loading...</Typography>
        </div>
    </div>
)

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"))

// Pages
const Login = React.lazy(() => import("./pages/login/Login"))
const SignUp = React.lazy(() => import("./pages/login/signup/Signup"))
const Page404 = React.lazy(() => import("./pages/page404/Page404"))
const Page500 = React.lazy(() => import("./pages/page500/Page500"))
const Landing = React.lazy(() => import("./pages/landing"))
const Category = React.lazy(() => import("./pages/category/Category"))
const AboutUs = React.lazy(() => import("./pages/about_us/AboutUs"))
const ContactUs = React.lazy(() => import("./pages/contact_us/ContactUs"))
const PrivacyPolicy = React.lazy(() => import("./pages/privacy_policy/PrivacyPolicy"))
const TermAndCondition = React.lazy(() => import("./pages/term_and_condition/TermAndCondition"))
const ForgotPassword = React.lazy(() => import("./pages/forgot-password/ForgotPassword"))
const ForgotPasswordSent = React.lazy(() => import("./pages/forgot_password_sent/ForgotPasswordSent"))
const ResetPassword = React.lazy(() => import("./pages/reset_password/ResetPassword"))
const ResetPasswordSuccess = React.lazy(() => import("./pages/reset_password_success/ResetPasswordSuccess"))
const PaymentReturnFail = React.lazy(() => import("./pages/payment_return_fail/PaymentReturnFail"))
const VerifyEmail = React.lazy(() => import("./pages/verify_email/VerifyEmail"))

const ViewMenu = React.lazy(() => import("./pages/menu/ViewMenu"))
const VerifyEmailOtp = React.lazy(() => import("./pages/login/verify_email_otp/VerifyEmailOtp"))
const Profile = React.lazy(() => import("./pages/profile/Profile"))
const ViewPackageStep1 = React.lazy(() => import("./pages/menu/package/ViewPackageStep1"))
const ViewPackageStep2 = React.lazy(() => import("./pages/menu/package/ViewPackageStep2"))
const ViewPackageStep3 = React.lazy(() => import("./pages/menu/package/ViewPackageStep3"))

const App = () => {
    return (
        <HashRouter>
            <Suspense fallback={loading}>
                <Routes>
                    <Route exact path="/login" name="Login Page" element={<Login />} />
                    <Route exact path="/sign-up" name="Sign Up Page" element={<SignUp />} />
                    <Route exact path="/404" name="Page 404" element={<Page404 />} />
                    <Route exact path="/500" name="Page 500" element={<Page500 />} />

                    <Route exact path="/menu" name="Menu" element={<ViewMenu />} />
                    <Route exact path="/verify-email-otp" name="Verify Email" element={<VerifyEmailOtp />} />
                    <Route exact path="/profile" name="Profile" element={<Profile />} />
                    <Route exact path="/package-step1" name="View Package" element={<ViewPackageStep1 />} />
                    <Route exact path="/package-step2" name="View Package Step 2" element={<ViewPackageStep2 />} />
                    <Route exact path="/package-step3" name="View Package Step 3" element={<ViewPackageStep3 />} />
                     
                    <Route exact path="/about-us" name="About Us" element={<AboutUs />} />
                    <Route exact path="/contact-us" name="Contact Us" element={<ContactUs />} />
                    <Route
                        exact
                        path="/privacy-policy"
                        name="Privacy Policy"
                        element={<PrivacyPolicy />}
                    />
                    <Route
                        exact
                        path="/term-and-condition"
                        name="Term and Condition"
                        element={<TermAndCondition />}
                    />
                    <Route
                        exact
                        path="/forgot-password"
                        name="Forgot Password"
                        element={<ForgotPassword />}
                    />
                    <Route
                        exact
                        path="/forgot-password-sent"
                        name="Forgot Password Sent"
                        element={<ForgotPasswordSent />}
                    />
                    <Route
                        path="/reset-password"
                        name="Reset Password"
                        element={<ResetPassword />}
                    />
                    <Route
                        exact
                        path="/reset-password-success"
                        name="Reset Password Success"
                        element={<ResetPasswordSuccess />}
                    />
                    <Route
                        exact
                        path="/reset-password-fail"
                        name="Reset Password Fail"
                        element={<PaymentReturnFail />}
                    />
                    <Route
                        exact
                        path="/verify-email"
                        name="Verify Email"
                        element={<VerifyEmail />}
                    />
                    <Route path="dashboard" name="Dashboard" element={<DefaultLayout />}>
                        {routes?.map((item, index) => (
                            <Route
                                key={index}
                                path={item?.path}
                                name={item?.name}
                                element={<item.element />}
                            />
                        ))}
                    </Route>
                    <Route path="/" name="Home" element={<Landing />} />
                    <Route path="/category" name="Category" element={<Category />} />
                    <Route path="/product" name="Product" element={<Product />} />
                    <Route path="/my-account" name="My Account" element={<MyAccount />} />
                    <Route path="*" name="Not Found" element={<Page404 />} />
                </Routes>
            </Suspense>
        </HashRouter>
    )
}

export default App
